import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface AccountNameHolderInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}

export default function AccountNameHolderInput({
  value,
  onChange,
  disabled,
}: AccountNameHolderInputProps) {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('formInputs.accountNameInputLabel')}
      variant='outlined'
      fullWidth
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
}
